import en from './en';
import vi from './vi';
import zh from './zh';
import ja from './ja';
import ko from './ko';
import ar from './ar';
import fr from './fr';
import es from './es';
import ru from './ru';
import hi from './hi';
import id from './id';
import pt from './pt';
import de from './de';
import it from './it';

export const locales = { en, vi, zh, ja, ko, ar, fr, es, ru, hi, id, de, pt, it } as const;

export type Locale = keyof typeof locales;

export const LOCALES: { code: Locale; label: string; dir?: 'rtl' }[] = [
  { code: 'en', label: 'English' },
  { code: 'vi', label: 'Tiếng Việt' },
  { code: 'zh', label: '中文' },
  { code: 'ja', label: '日本語' },
  { code: 'ko', label: '한국어' },
  { code: 'ar', label: 'العربية', dir: 'rtl' },
  { code: 'fr', label: 'Français' },
  { code: 'es', label: 'Español' },
  { code: 'ru', label: 'Русский' },
  { code: 'hi', label: 'हिन्दी' },
  { code: 'id', label: 'Indonesia' },
  { code: 'de', label: 'Deutsch' },
  { code: 'pt', label: 'Português' },
  { code: 'it', label: 'Italiano' },
];

// Ngôn ngữ mặc định của toàn bộ app (client + server), cấu hình qua .env: NEXT_PUBLIC_DEFAULT_LOCALE
// Fallback về 'en' nếu biến env không được set hoặc giá trị không hợp lệ (không nằm trong `locales`)
function resolveDefaultLocale(): Locale {
  const envLocale = process.env.NEXT_PUBLIC_DEFAULT_LOCALE as Locale | undefined;
  if (envLocale && envLocale in locales) return envLocale;
  return 'en';
}

export const DEFAULT_LOCALE: Locale = resolveDefaultLocale();

// Mapping Locale → OpenGraph locale string (og:locale dùng format xx_XX)
export const OG_LOCALE_MAP: Record<Locale, string> = {
  en: 'en_US',
  vi: 'vi_VN',
  zh: 'zh_CN',
  ja: 'ja_JP',
  ko: 'ko_KR',
  ar: 'ar_AR',
  fr: 'fr_FR',
  es: 'es_ES',
  ru: 'ru_RU',
  hi: 'hi_IN',
  id: 'id_ID',
  de: 'de_DE',
  pt: 'pt_BR',
  it: 'it_IT',
};

export { en };
export type { Translations } from './en';